const topBarActionsTypes = {
    CHANGE_SEARCH_FIELD: "CHANGE_SEARCH_FIELD"
};

export default topBarActionsTypes;